var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13253_6161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.5001H6.74987C6.00546 19.4992 5.26975 19.34 4.59157 19.033C3.91338 18.7261 3.30823 18.2784 2.81626 17.7197C2.3243 17.1611 1.95676 16.5042 1.73805 15.7926C1.51934 15.081 1.45445 14.3311 1.54769 13.5925C1.64093 12.854 1.89017 12.1437 2.27886 11.5088C2.66756 10.874 3.18682 10.329 3.80221 9.91013C4.41759 9.49125 5.11501 9.20803 5.8482 9.07926C6.58139 8.9505 7.33359 8.97912 8.05487 9.16324",
    stroke: "#735BF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.0001L14.25 12.0001L17.25 15.0001",
    stroke: "#735BF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.5001V12.0001",
    stroke: "#735BF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.0001C7.50032 10.648 7.86615 9.3211 8.55877 8.15988C9.2514 6.99866 10.2451 6.04627 11.4346 5.4035C12.6242 4.76073 13.9653 4.45149 15.3162 4.5085C16.6671 4.56551 17.9775 4.98666 19.1087 5.72736C20.2398 6.46807 21.1497 7.5008 21.742 8.71625C22.3344 9.9317 22.5871 11.2847 22.4735 12.632C22.3599 13.9793 21.8842 15.2709 21.0967 16.37C20.3092 17.4691 19.2392 18.3349 18 18.8757",
    stroke: "#735BF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13253_6161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp);
export default __webpack_public_path__ + "static/media/CloudArrowUp.e03d0a4fc08898596676ce9a40c24031.svg";
export { ForwardRef as ReactComponent };